import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import alertReducer from "./alert-store";
import apiKeyReducer from "./api_key-store";
import settingReducer from "./setting-store";
import projectReducer from "./project-store";
import submissionReducer from "./submission-store";

const store = new configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    api_key: apiKeyReducer,
    settings: settingReducer,
    project: projectReducer,
    submission: submissionReducer,
  },
});

//After every store element update return tree structure and single element like store.getState().alert
store.subscribe(() => {
  // console.log(store.getState().alert);
});

export default store;
